import React, { useState } from 'react'
import ImageCarousel from '/src/components/carousel/ImageCarousel'

import './image_gallery.scss'

export const ImageGallery = ({ images }) => {
  if (!images.length) {
    return <></>
  }

  return (
    <div className="image-gallery-container d-flex justify-content-center align-items-center">
      <div className="image-gallery-inner">
        <div className="image-gallery">
          <ImageCarousel images={images} />
        </div>
      </div>
    </div>
  )
  /*return (
    <Modal display={display} setDisplay={setDisplay}>
      <ProductVariationsTable variations={variations} />
    </Modal>
  )*/
}

export default ImageGallery
